const pubsub = require('../utils/pubsub'),
	screenUtil = require('../utils/screen');

let breakpoints,
	currentBreakpoint;

_setEventListeners();

function init(settings) {
	_validateBreakpoints(settings.breakpoints);

	breakpoints = JSON.parse(JSON.stringify(settings.breakpoints));
	currentBreakpoint = getCurrentBreakpoint();
}

function _setEventListeners() {
	pubsub.subscribe('resize', function() {
		if (typeof breakpoints === 'undefined') {
			return;
		}

		const previousBreakpoint = currentBreakpoint;

		currentBreakpoint = getCurrentBreakpoint();

		if (previousBreakpoint !== currentBreakpoint) {
			pubsub.publish('breakpoint.changed', currentBreakpoint);
		}
	});
}

function _validateBreakpoints(bps) {
	const values = [];

	Object.keys(bps).forEach((bp) => {
		if (typeof bps[bp] !== 'number' || bps[bp] < 0) {
			throw new Error(`Invalid breakpoint '${bp}'. '${bps[bp]}' is not a number or less than zero.`);
		}

		if (values.indexOf(bps[bp]) !== -1) {
			throw new Error(`Invalid breakpoint '${bp}'. Breakpoint at '${bps[bp]}' already exists.`);
		}

		values.push(bps[bp]);
	});

	if (Math.min(...values) > 0) {
		bps['0'] = 0;
	}
}

function getCurrentBreakpoint() {
	const screenWidth = screenUtil.getSize().width;

	return Object.keys(breakpoints).reduce((agg, bp) => {
		if (breakpoints[bp] <= screenWidth && breakpoints[bp] > breakpoints[agg]) {
			agg = bp;
		}

		return agg;
	});
}

function getBreakpoints() {
	return breakpoints;
}

module.exports = {
	init,
	getCurrentBreakpoint,
	getBreakpoints
};
